<div class="card" style="width: 100%">
  <div class="card-header-white header-underline">
    <h6 class="white-header-text">{{ 'ADD_NEW_DEVICE' |translate }}</h6>
    <span class="fa-light fa-xmark float-right cardCloseBtn" (click)="closeEvent.emit()"></span>
  </div>

  <div class="card-body-white pt-2">
    @if (errorMsg$.value) {
      <div class="alert alert-danger">
        {{ errorMsg$.value | translate }}
      </div>
    }

    @if (informationMsg$.value) {
      <div class="alert alert-info">
        {{ informationMsg$.value | translate }}
      </div>
    }

    <div class="from-group">
      <label><strong>{{ 'DEVICE_TYPE' | translate }}</strong></label>
    </div>

    <mat-form-field appearance="outline">
      <mat-select [(ngModel)]="selectedDeviceType">
        <mat-option [value]="'everon-device'">{{ 'Everon ' + ('DEVICE' | translate | lowercase) }}</mat-option>
        <mat-option [value]="'everwatch'">EverWatch</mat-option>
        <mat-option [value]="'nightowl'">Nightowl</mat-option>
      </mat-select>
    </mat-form-field>

    @switch (selectedDeviceType) {
      @case ('everon-device') {
        <app-add-device-form
          [locations]="locations"
          [errorMsg$]="errorMsg$"
          [informationMsg$]="informationMsg$"
          (savedEvent)="savedEvent.emit($event)"
        ></app-add-device-form>
      }
      @case ('everwatch') {
        <app-everwatch-form
          [locations]="locations"
          [errorMsg$]="errorMsg$"
          (savedEvent)="savedEvent.emit($event)"
        ></app-everwatch-form>
      }
      @case ('nightowl') {
        <app-nightowl-form
          [locations]="locations"
          [errorMsg$]="errorMsg$"
          (savedEvent)="savedEvent.emit($event)"
        ></app-nightowl-form>
      }
    }
  </div>
</div>
